import React, { memo, useState } from 'react'
import styles from './input.module.css'
import openEye from '../../icons/openEye.png'
import eye from '../../icons/eye.svg'
const Input = ({ label, type = 'text', value, onChange, id, placeHolder, style, errText, autoComplete }) => {
  const [pswdType, setPswdType] = useState('password')
  function changeInputType() {
    setPswdType(pswdType === 'password' ? 'text' : 'password')
  }
  return (
    <div className={styles.inputGroup}>
      <label htmlFor={id} className={styles.label}> {label} </label>
      <input
        id={id}
        type={type === 'password' ? pswdType : type}
        value={value}
        placeholder={placeHolder}
        onChange={onChange}
        style={style}
        className={styles.input}
        autoComplete={autoComplete}
      />
      {type === 'password' ? <img className={styles.eyeIcon} src={pswdType === 'password' ? eye : openEye} alt='show' onClick={() => changeInputType()} /> : null}
      {errText ? <p style={{ color: 'red', textAlign: 'left' }}>{errText}</p> : null}
    </div>
  );
};

export default memo(Input);
